// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2WR2uug3COQAt8jqZ5SpO4{margin-top:1rem}", "",{"version":3,"sources":["webpack://./resources/js/components/PostView/DeveloperPostContent/DeveloperPostSections/BuildingProperties/styles.module.scss"],"names":[],"mappings":"AAAA,yBACI,eACJ","sourcesContent":[".section_header {\n    margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section_header": "_2WR2uug3COQAt8jqZ5SpO4"
};
export default ___CSS_LOADER_EXPORT___;
